import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { EncouragementEvent } from './encouragement_events';

@Injectable({ providedIn: 'root' })
export class EncouragementEventProvider extends DomainEventProvider<EncouragementEvent> {}
